import React from 'react';
import { Box, useBreakpointValue } from '@chakra-ui/react';
import Header from '../Components/Header';
import MainLayout from '../Components/MainLayout';
import DashboardStateManager from '../Components/DashboardStateManager';
import { useUIStore } from '../store/uiStore';

const AutoMDDashboard = () => {
  // Zustand stores
  const {
    isSidebarOpen,
    isMobileDrawerOpen,
    isChatView,
    isSettingsView,
    toggleSidebar,
    toggleMobileDrawer,
  } = useUIStore();
  
  // Responsive behavior
  const isMobile = useBreakpointValue({ base: true, lg: false });
  const showSidebar = !isMobile && isSidebarOpen;
  const showDrawer = isMobile && isMobileDrawerOpen;
  
  // Handle menu click based on device type
  const handleMenuClick = () => {
    if (isMobile) {
      toggleMobileDrawer();
    } else {
      toggleSidebar();
    }
  };

  return (
    <DashboardStateManager>
      {({
        handleVehicleSelect,
        handleLogout,
        handleSettingsClick,
        handleBackToDashboard,
        handleBackToSettings,
        handleChatSubmit,
        handleClearChat,
        messagesLoading,
      }) => (
        <Box bg="white" minH="100vh">
          {/* Header - Hide when in Settings view */}
          {!isSettingsView && (
            <Header
              isMobile={isMobile}
              onMenuClick={handleMenuClick}
              isChatView={isChatView}
              onBackToDashboard={handleBackToDashboard}
            />
          )}

          {/* Main Layout with Sidebar */}
          <MainLayout
            isMobile={isMobile}
            showSidebar={showSidebar}
            showDrawer={showDrawer}
            isOpen={showDrawer}
            onClose={toggleMobileDrawer}
            isSettingsView={isSettingsView}
            isChatView={isChatView}
            onChatSubmit={handleChatSubmit}
            onSettingsClick={handleSettingsClick}
            onVehicleSelect={handleVehicleSelect}
            onBackToSettings={handleBackToSettings}
            onClearChat={handleClearChat}
            onProcessManagement={undefined}
            messagesLoading={messagesLoading}
          />
        </Box>
      )}
    </DashboardStateManager>
  );
};

export default AutoMDDashboard;